import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { clientUsersListQueryOptions } from '~bank-client-users/service/clientUsersListQueryOptions'
import { clientUsersListFilterParamsSchema } from '~bank-client-users/types'

export const clientUsersListRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    validateSearch: (search: Record<string, unknown>) => clientUsersListFilterParamsSchema.parse(search),
    loaderDeps: (all) => ({ ...all.search }),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(clientUsersListQueryOptions(deps))
    },
    component: lazyRouteComponent(() => import('./ClientUsers'))
  })
